import { render, staticRenderFns } from "./NewBuildingView.vue?vue&type=template&id=82d79226"
import script from "./NewBuildingView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewBuildingView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports